import styled from 'styled-components';

export const StyledLocations = styled.section`
  .row > picture {
    padding-right: calc(1rem * 0.5);
    padding-left: calc(1rem * 0.5);
  }
  &.lt-unicef-locations {
    .row > * {
      flex-shrink: 0;
      width: 100%;
      max-width: 100%;
      margin-top: 0;
    }
  }
  &.lt-locations .miniCardContent .miniCardBody {
    max-width: 80%;
  }
`;
